import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { IApiMTradingAccount } from '@api/interfaces/data-contracts';
import { useTradingAccountActions } from '@components-member/TradingAccounts/hooks/useAccountCardActions';
import { IAction } from '@components-member/TradingAccounts/interfaces';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import { IOnboardingConfiguration } from 'global.interfaces';
import { observer } from 'mobx-react';

interface IAccountDetailsTabsProps {
  rootPath: string;
  account: IApiMTradingAccount;
  onboardingConfiguration: IOnboardingConfiguration;
}

const AccountDetailsTabs = observer((props: IAccountDetailsTabsProps): JSX.Element => {
  const { rootPath, account, onboardingConfiguration } = props;
  const { i18n } = useTranslation();

  const actions = useTradingAccountActions(
    account.id,
    account.groupMappingType,
    account.investorId,
    account.masterId,
    account.accountType,
    account.currency,
    onboardingConfiguration.showCopyTradingTab,
    account.enabled,
  );

  return (
    <div className="tab-list__wrap">
      <div className="tab-list">
        {actions.map((action: IAction) => (
          <NavLink
            key={action.link}
            to={`${rootPath}/${action.link}`}
            className="tab-list__tab"
            activeClassName="active">
            {i18n.t(action.title as KeyMapKeys)}
          </NavLink>
        ))}
      </div>
    </div>
  );
});

export default AccountDetailsTabs;
